export const DEFAULT_DESKTOP_SITE_WIDTH = 980

export const MOBILE_SITE_WIDTH = 320

export const EMPTY_OBJECT: Record<string, any> = {}
export const EMPTY_ARRAY: Array<never> = []

export const SOSP_CONTAINER_ID = 'SOSP_CONTAINER_CUSTOM_ID'

export const VISIBILITY_HIDDEN = { visibility: 'hidden' } as const
export const VISIBILITY_VISIBLE = { visibility: 'visible' } as const
